import { trace } from 'rytm-helpers'
import Controller from './Controller'


class TaxonomyController extends Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e)
  }
  addEventListeners() {
    super.addEventListeners()
    const selector = "div" + this.getContainerSelector()
    $("body").on("shown.bs.dropdown", selector, $.proxy(this.onDropdownShown, this))
    $("body").on("keyup", selector + " input.form-control", $.proxy(this.onInputChange, this))
  }
  removeEventListeners() {
    super.removeEventListeners()
    const selector = "div" + this.getContainerSelector()
    $("body").off("shown.bs.dropdown", selector, $.proxy(this.onDropdownShown, this))
    $("body").off("keyup", selector + " input.form-control", $.proxy(this.onInputChange, this))
  }

  /**
   * OWN
   */
  onDropdownShown(e) {
    const input = this.getInput()
    if (input) {
      input.focus()
    }
  }
  onInputChange(e) {
    const value = e.currentTarget.value
    if (value) {
      this.filterOptions(value)
    } else {
      this.resetFilter()
    }
  }
  filterOptions(value) {
    const options = this.getOptions()
    let resultsCount = 0
    options.forEach((el) => {
      if (!this.validateValue(el, value)) {
        el.classList.add("disabled")
      } else {
        el.classList.remove("disabled")
        resultsCount++
      }
    })
    this.updateDropdownState(resultsCount)
  }
  resetFilter() {
    const options = this.getOptions()
    options.forEach((el) => {
      el.classList.remove("disabled")
    })
  }
  validateValue(el, value) {
    let result = false
    const span = el.querySelector("span")
    const myTxt = span ? span.innerHTML : el.innerHTML
    if (myTxt.toUpperCase().indexOf(value.toUpperCase()) > -1) {
      result = true
    }
    return result;
  }
  updateDropdownState(resultsCount) {
    const container = document.querySelector(this.getContainerSelector())
    if (resultsCount > 0) {
      container.classList.remove("no-search-results")
    } else {
      container.classList.add("no-search-results")
    }
  }

  getInput() {
    const selector = "div" + this.getContainerSelector()
    return document.querySelector(selector + " input.form-control")
  }
  getOptions() {
    const selector = "div" + this.getContainerSelector()
    return [...document.querySelectorAll(selector + " .dropdown-item")]
  }
  
  
}

export default TaxonomyController;